'use strict';

var App = App || {};

App.SlideshowPage = function () {
  "use strict";

  var $body = $('body'),
      $heroSlides = $('.hero-slides');

  var initialize = function initialize() {
    if (!$body.hasClass('template-slideshow-page')) return false;
    _initHeroSlides();
  };

  var _initHeroSlides = function _initHeroSlides() {
    $heroSlides.slick({
      arrows: false,
      autoplay: true,
      autoplaySpeed: 4000,
      mobileFirst: true,
      pauseOnFocus: false,
      pauseOnHover: false,
      fade: true,
      speed: 3000,
      responsive: [{
        breakpoint: 641,
        settings: {
          dots: true
        }
      }]
    });
  };

  return {
    initialize: initialize
  };
}();